import React, { useRef, useEffect } from 'react';
import GoogleMapsWrapper from './GoogleMapsWrapper';

interface MapViewProps {
  latitude: number;
  longitude: number;
  address?: string;
  className?: string;
  height?: string;
}

interface GoogleMapDisplayProps {
  center: google.maps.LatLngLiteral;
  address?: string;
  height: string;
}

const GoogleMapDisplay: React.FC<GoogleMapDisplayProps> = ({ center, address, height }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      const map = new window.google.maps.Map(ref.current, {
        center,
        zoom: 15,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        gestureHandling: 'cooperative'
      });

      // Add marker
      new window.google.maps.Marker({
        position: center,
        map,
        title: address || 'Incident Location'
      });

      // Add info window if address is available
      if (address) {
        const infoWindow = new window.google.maps.InfoWindow({
          content: `<div style="padding: 8px;"><strong>Incident Location</strong><br/>${address}</div>`
        });

        const marker = new window.google.maps.Marker({
          position: center,
          map,
          title: address
        });

        marker.addListener('click', () => {
          infoWindow.open(map, marker);
        });

        // Auto-open info window
        setTimeout(() => {
          infoWindow.open(map, marker);
        }, 1000);
      }
    }
  }, [center, address]);

  return <div ref={ref} className={`w-full rounded-lg border border-gray-300`} style={{ height }} />;
};

const MapView: React.FC<MapViewProps> = ({
  latitude,
  longitude,
  address,
  className = '',
  height = '300px'
}) => {
  const center = { lat: latitude, lng: longitude };

  // Don't render if no coordinates
  if (!latitude || !longitude) {
    return (
      <div className={`w-full bg-gray-50 border border-gray-200 rounded-lg flex items-center justify-center p-8 ${className}`}>
        <p className="text-gray-500 text-sm">No location coordinates available</p>
      </div>
    );
  }

  return (
    <div className={className}>
      <GoogleMapsWrapper>
        <GoogleMapDisplay
          center={center}
          address={address}
          height={height}
        />
      </GoogleMapsWrapper>
    </div>
  );
};

export default MapView;